import serviceLinkApi from "../api/service-link-api";

const add = async (payload) => {
    const resp = await serviceLinkApi.add(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    const resp = await serviceLinkApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (payload) => {
    const resp = await serviceLinkApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await serviceLinkApi.search(condition, pagination);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const saveDisplay = async (payload) => {
    const resp = await serviceLinkApi.saveDisplay(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const getDisplay = async () => {
    const resp = await serviceLinkApi.getDisplay();
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const serviceLinkService = {
    add,
    edit,
    remove,
    search,
    saveDisplay,
    getDisplay
};

export default serviceLinkService;